import ajax from '../utils/ajax';

/** @typedef {import("./types").SubmitResponse} SubmitResponse */


async function submit(formData) {
  /** @type {SubmitResponse} */
  const res = await ajax.postWithRequestVerificationToken('/api/onepage/onepagegiving/submit', formData);

  if (!res.type) {
    throw new Error();
  }

  return res;
}


export default {
  submit,
};



// WEBPACK FOOTER //
// ./src/onePageGiving/OnePageGivingService.js